// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CategoryPage.css */

.category-page-container {
    min-height: 100vh;
    position: relative;
    background-color: black;
    background-image: url('https://www.transparenttextures.com/patterns/stardust.png');
    background-repeat: repeat;
    background-position: top center;
    overflow: hidden;
    animation: starAnimation 250s linear infinite;
}

@keyframes starAnimation {
    from { background-position: 0 0; }
    to { background-position: -2000px 1000px; }
}

.content12 {
    position: relative;
    z-index: 1;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: white;
}

.selected-category-title {
    text-align: center;
    font-size: 1.5em;
    margin-bottom: 20px;
    color: white;
    text-shadow: #ccc 1px 1px 1px;
    padding-top: 5px;
    padding-bottom: 5px;
}

.product-list-container {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    justify-content: center;
    width: 100%;
    max-height: 60vh; /* Maximale sichtbare Höhe */
    overflow-y: auto; /* Ermöglicht vertikales Scrollen */
    padding-right: 10px; /* Platz für die Scrollbar */
}

.product-item-card {
    width: 100%;
    max-width: 300px;
    padding: 15px;
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 0.075);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    color: white;
    opacity: 0;
    transform: translateX(-30px);
}

.fade-in-animation {
    animation: fadeInSlideIn 0.6s ease forwards;
}

@keyframes fadeInSlideIn {
    0% {
        opacity: 0;
        transform: translateX(-30px);
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
}

.product-item-title {
    font-size: 1.2em;
    font-weight: bold;
    margin-bottom: 8px;
    text-align: center;
}

.product-item-details {
    display: flex;
    justify-content: space-between;
    gap: 75px;
    width: 100%;
    font-size: 0.9em;
    margin-bottom: 8px;
}

.product-item-quantity,
.product-item-price {
    font-size: 0.9em;
}

.product-item-ingredients {
    font-size: 0.8em;
    color: #888;
    text-align: center;
}

.ingredients {
    text-align: center;
    color: white;
    margin-top: 20px;
}

.no-products {
    text-align: center;
    color: #888;
    font-size: 1em;
}

.back-button {
    display: block;
    margin: 30px auto;
    padding: 10px 20px;
    font-size: 1em;
    font-weight: bold;
    color: white;
    background-color: rgba(255, 255, 255, 0.075);
    border: 1px solid #ccc;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.back-button:hover {
    background-color: #666;
}

@media (max-width: 768px) {
    .product-list-container {
        max-height: 65vh;
    }
}

@media (max-width: 480px) {
    .product-list-container {
        max-height: 49vh;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/components/CategoryPage.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;IACI,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,kFAAkF;IAClF,yBAAyB;IACzB,+BAA+B;IAC/B,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA;IACI,OAAO,wBAAwB,EAAE;IACjC,KAAK,mCAAmC,EAAE;AAC9C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,WAAW;IACX,gBAAgB,EAAE,4BAA4B;IAC9C,gBAAgB,EAAE,mCAAmC;IACrD,mBAAmB,EAAE,4BAA4B;AACrD;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,4CAA4C;IAC5C,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["/* CategoryPage.css */\n\n.category-page-container {\n    min-height: 100vh;\n    position: relative;\n    background-color: black;\n    background-image: url('https://www.transparenttextures.com/patterns/stardust.png');\n    background-repeat: repeat;\n    background-position: top center;\n    overflow: hidden;\n    animation: starAnimation 250s linear infinite;\n}\n\n@keyframes starAnimation {\n    from { background-position: 0 0; }\n    to { background-position: -2000px 1000px; }\n}\n\n.content12 {\n    position: relative;\n    z-index: 1;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: white;\n}\n\n.selected-category-title {\n    text-align: center;\n    font-size: 1.5em;\n    margin-bottom: 20px;\n    color: white;\n    text-shadow: #ccc 1px 1px 1px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n}\n\n.product-list-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 15px;\n    justify-content: center;\n    width: 100%;\n    max-height: 60vh; /* Maximale sichtbare Höhe */\n    overflow-y: auto; /* Ermöglicht vertikales Scrollen */\n    padding-right: 10px; /* Platz für die Scrollbar */\n}\n\n.product-item-card {\n    width: 100%;\n    max-width: 300px;\n    padding: 15px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    background-color: rgba(255, 255, 255, 0.075);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n    color: white;\n    opacity: 0;\n    transform: translateX(-30px);\n}\n\n.fade-in-animation {\n    animation: fadeInSlideIn 0.6s ease forwards;\n}\n\n@keyframes fadeInSlideIn {\n    0% {\n        opacity: 0;\n        transform: translateX(-30px);\n    }\n    100% {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n.product-item-title {\n    font-size: 1.2em;\n    font-weight: bold;\n    margin-bottom: 8px;\n    text-align: center;\n}\n\n.product-item-details {\n    display: flex;\n    justify-content: space-between;\n    gap: 75px;\n    width: 100%;\n    font-size: 0.9em;\n    margin-bottom: 8px;\n}\n\n.product-item-quantity,\n.product-item-price {\n    font-size: 0.9em;\n}\n\n.product-item-ingredients {\n    font-size: 0.8em;\n    color: #888;\n    text-align: center;\n}\n\n.ingredients {\n    text-align: center;\n    color: white;\n    margin-top: 20px;\n}\n\n.no-products {\n    text-align: center;\n    color: #888;\n    font-size: 1em;\n}\n\n.back-button {\n    display: block;\n    margin: 30px auto;\n    padding: 10px 20px;\n    font-size: 1em;\n    font-weight: bold;\n    color: white;\n    background-color: rgba(255, 255, 255, 0.075);\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.back-button:hover {\n    background-color: #666;\n}\n\n@media (max-width: 768px) {\n    .product-list-container {\n        max-height: 65vh;\n    }\n}\n\n@media (max-width: 480px) {\n    .product-list-container {\n        max-height: 49vh;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
